/**
 * Order
 */

let initAddressForm = {
    address: '',
}

// let initPickupPointForm = {
//     name: '',
//     address: '',
// }

export const delivery = {
    namespaced: true,

    state: () => ({
        deliveries: [],
        addresses: [],
        // pickup_points: [],
        delivery: {},
        address: {...initAddressForm},
        // pickup_point: {...initPickupPointForm},
    }),

    mutations: {
        setDeliveries: (state, payload) => {
            state.deliveries = payload.items;
        },
        
        setDelivery: (state, payload) => {
            state.delivery = payload.data;
        },

        setAddresses: (state, payload) => {
            state.addresses = payload.items;
        },

        // setPickupPoints: (state, payload) => {
        //     state.pickup_points = payload.items;
        // },
        
        setAddress: (state, payload) => {
            state.address = payload.data;
        },

        resetErrors: (state, payload) => {
            state.errors = {};
        },

        resetForm: (state, payload) => {
            state.errors = {};
            state.editMode = false;
            state.address = {...initForm};
        },

        setSaving: (state, payload) => {
            state.saving = payload;
        },
    },
    
    actions: {
        getDeliveries: async ({ commit }) => {
            let { data } = await axios.get('/ajax/delivery');

            commit('setDeliveries', data);
        },

        getDelivery: ({ commit, dispatch }, payload) => {
            return axios.get('/ajax/delivery/' + payload)
                .then(request => commit('setDelivery', request.data));
        },

        getAddresses: async ({ commit }) => {
            let { data } = await axios.get('/ajax/address');

            commit('setAddresses', data);
        },

        // getPickupPoints: async ({ commit }) => {
        //     let { data } = await axios.get('/ajax/pickup');

        //     commit('setPickupPoints', data);
        // },

        getAddress: ({ commit, dispatch }, payload) => {
            return axios.get('/ajax/address/' + payload)
                .then(request => commit('setAddress', request.data));
        },

        addAddress: ({ commit, dispatch, state }, payload) => {
            let params = {
                ...state.address,
            };

            commit('setSaving', true);

            axios.post('/ajax/address/store', params)
                .then(request => {
                    commit('setSaving', false);
                    dispatch('getAddresses');
                });
        },

        // updateAddress: ({ commit, dispatch, state }, payload) => {
        //     let params = {
        //         ...state.address,
        //     };

        //     axios.put('/ajax/address/update', params)
        //         .then(request => {
        //             commit('setSaving', false);
        //             dispatch('getAddresses');
        //         });
        // },

        deleteAddress: ({ commit, dispatch }, payload) => {
            axios.delete('/ajax/address/destroy/' + payload)
                .then(request => dispatch('getAddresses'));
        },
    },

    getters: {
    }
}